<template>
  <div>
      <div class="VueCarousel-slide active" ref="story1">
        <div class="padding">
          <div>
            <p>I know who you were. But I don't know where you are. </p>
           <br>
 <p>I see you out of the corner of my eye, but always gone when i turn.</p>
            <br>
<p>i see you in my sleep and in my waking dreams.</p>
            <p> &nbsp;</p>
            <br>
<p>People seem to forget what it was like here, a building disappears and the next day they just walk through the gap as if they have always done, a wall appears and they just find another route, i want to show them my maps, my notes, my documents, but i know they won't trust them.</p>
            <br>
<p>I think about the passage of all these things, I don't know where they go or where they come from, but somehow i know that's where I'd find you, why won't you step into the light and let me see you.</p>
            <br>
<p>Oska says I have to write you, just the way he remembers you, the way I remember you, but there are things I'd miss, things I'd get wrong... I can't even remember where we were last together...</p>
           <br>
 <p>If I do as Oska asks, what then?  If I fix this city to the page, is it right to do the same to you?</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </div>
      <div class="VueCarousel-slide hidden" ref="story2">
        <div class="padding">
          <div>
            <span class="arch">
              <p>Here. It happened here. </p>
              <p> &nbsp;</p>
              <br>
<p>The bench wobbles underneath me as my knee twitches. I look at the bottom of my cup, the coffee marking out its own traces in the remains of the milk froth. It looks like islands, a map of a place i could imagine but never visit.</p>
              <p> &nbsp;</p>
             <br>
 <p>I've been here for hours, and not just today. Every one of the last few days I find myself drawn back here.</p>
              <br>
<p>At first I thought it was because it was surrounded by fluidity, by a constantly changing geography of earth and mud, plastic and metal. Watching how easily these people tear up and reconstruct the landscape, maybe I thought they would rip it apart so hard that somehow they would pull out the place I know I should be. </p>
              <p> &nbsp;</p>
              <br>
<p>But that's not it.</p>
              <p> &nbsp;</p>
              <br>
<p>I realise now that I come here because I know this place, that I've been here before. It's not the same, it doesn't look the same, but..</p>
              <p> &nbsp;</p>
             <br>
 <p>The last place I stood and was real. </p>
             <br>
 <p>This place reminds me of it, no, not just reminds me, it's an echo. </p>
             <br>
 <p>Something happened here. </p>
 <p>Like a door opening and empty air beyond its hearth.</p>
              <p> &nbsp;</p>
              <br>
<p>A rushing sensation, like falling. </p>
              <p> &nbsp;</p>
              <br>
<p>Falling.</p>
              <p> &nbsp;</p>
              <br>
<p>It happened here. </p>
              <p> &nbsp;</p>
             <br>
 <p>And now I just haunt this site, this empty place nestling in the in-between. I've become a ghost in this city, I don't want to be here.</p>
              <p> &nbsp;</p>
              <br>
<p>I lost her,</p>
              <p> &nbsp;</p>
              <br>
<p>and I lost something else too. </p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Here',
      story: 1
    }
  },
  computed: {
    inputListeners: function () {
      // `Object.assign` merges objects together to form a new object
      return Object.assign({},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
        }
      )
    }
  },
  methods: {
    swipe () {
      console.log('swipe')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
